import { Deserializable } from '@sparte/utils';


export class ResourceLibrary implements Deserializable {
  public id: string;
  public designation: string;
  public created_at: Date;
  public updated_at: Date;
  public readonly typeName = "ResourceLibrary";

  deserialize(input: any): this {
    const { __typename, library_id, created_at, updated_at, ..._input } = input;
    Object.assign(this, _input);
    this.id = library_id;
    this.created_at = new Date(created_at);
    this.updated_at = new Date(updated_at);
    return this;
  }

  get label(): string {
    return this.designation;
  }

  get whereUniqueValue() {
    return {
      library_id: this.id
    }
  }

  get createValue() {
    const {
      created_at,
      updated_at,
      typeName,
      ..._this
    } = this;
    return _this;
  }

  get updateValue() {
    const {
      created_at,
      updated_at,
      typeName,
      ..._this
    } = this;
    return _this;
  }

  get searchTerm(): string {
    return this.designation.toLowerCase();
  }
}